import { Component } from '@angular/core';

@Component({
  selector: 'otp-info-card',
  imports: [],
  templateUrl: './otp-info-card.component.html',
  styleUrl: './otp-info-card.component.css',
})
export class OtpInfoCardComponent {}
